export enum WallType {
    SandwichPanel = 1, // Sandwich paneel
    LarssenSheetPiling = 2, // Damwand
    Clapboard = 3, // Potdeksel
    ClapboardAndSandwichPanel = 4 // Potdeksel sandwich paneel
};